import API from '../../../../../services/api';
import { headers } from '../helpers/functionalities';

export const API_PRESUPUESTOS = {
    getPresupuestos: async (page = null, search = null) => {
        const pagination = page !== null ? '?page=' + page : '';
        const searcher = search !== null && page !== null ? '&' + search : search !== null ? '?' + search : '';
        return await API.get('/presupuestos' + pagination + searcher).then(res => res.data);
    },
    getPresupuestoCompleto: async (idPresupuesto) => {
        return API.get('/presupuestos/' + idPresupuesto).then(res => res.data);
    },
    generatePresupuestoPDF: async (presupuestoId) => {
        return API.get('/presupuestos/generate_pdf/' + presupuestoId, {responseType: 'blob'}).then(res => res.data);
    },
    calcularTotal: async (presupuestoId) => {
        return API.get('/presupuestos/calcular_total/' + presupuestoId).then(res => res.data);
    },
    enablePresupuesto: async (presupuestoId) => {
        return API.get('/presupuestos/' + presupuestoId + '/enable').then(res => res.data);
    },
    disablePresupuesto: async (presupuestoId) => {
        return API.get('/presupuestos/' + presupuestoId + '/disable').then(res => res.data);
    },
    duplicatePresupuesto: async (presupuestoId) => {
        return API.get('/presupuestos/' + presupuestoId + '/duplicate').then(res => res.data);
    },
    changePresupuestoCliente: async (presupuestoId, cliente) => {
        return API.post('/presupuestos/' + presupuestoId + '/cliente', cliente).then(res => res.data);
    },
    newPresupuesto: async (presupuesto) => {
        return API.post('/presupuestos', presupuesto, headers).then(res => res.data);
    },
    newPresupuestoFromFile: async (presupuesto) => {
        return API.post('/presupuestos/file', presupuesto, headers).then(res => res.data);
    },
    actualizarPreciosCompra: async (presupuesto) => {
        return API.post('/presupuestos/' + presupuesto.id + '/precios_compra', presupuesto).then(res => res.data);
    },
    updatePresupuestoInfo: async (presupuesto, id) => {
        return API.post('/presupuestos/' + id + '/update', presupuesto, headers).then(res => res.data);
    },
    updatePresupuestoServicioEnvio: async (servicio, id) => {
        return API.post('/presupuestos/' + id + '/servicios_envio', servicio).then(res => res.data);
    },
    validatePresupuesto: async (presupuesto, id) => {
        return API.post('/presupuestos/' + id + '/validate', presupuesto).then(res => res.data);
    },
    exportPresupuestosClientes: async (filters) => {
        return API.post('/presupuestos/export/clientes', filters, {responseType: 'blob'}).then(res => res.data);
    },
    updatePresupuestoDireccionEnvio: async (direccionId, id) => {
        return API.put('/presupuestos/' + id, {direccion_envio_id: direccionId}).then(res => res.data);
    },
    updatePresupuestoIVA: async (presupuestoId, presupuesto) => {
        return API.put('/presupuestos/' + presupuestoId, presupuesto).then(res => res.data);
    },
    deletePresupuesto: async (idPresupuesto) => {
        return API.delete('/presupuestos/' + idPresupuesto).then(res => res.data);
    },
    enviarNotificacionResponsable: async (validacion) => {
        return API.post('/presupuestos/validate-notificacion', validacion).then(res => res.data);
    },
    enviarNotificacionRecambista: async (presupuestoId, validacion) => {
        return API.post('/presupuestos/' + presupuestoId + '/no-validate-notificacion',validacion).then(res => res.data);
    },
    getPendientesEcommerce: async () => {
        return API.get('/presupuestos/pendientes-ecommerce').then(res => res.data)
    },
    sendEmailPendientesEc: async (presupuestos) => {
        return API.post('/presupuestos/send-email-pendientes-ec', {presupuestos}).then(res => res.data)
    },
}